export enum SocketEventTypeEnum {
  Received = "6d9d292e-c67f-4d48-a720-5790132c6eb4",
  RowCount = "7d88d798-2d97-4f31-8063-40d8c295410b",
  Progress = "0349b43b-ca0e-49a1-87d2-1c87eeab2206",
  Message = "bff60518-e2f5-4ea5-a3b2-cb6c4191c9c2",
  Error = "1c517730-54b1-4127-b65c-6b3ad2d9fd77",
  AuthError = "77c40b7c-c3b0-4709-b7fb-74f0adb3dd23",
  Auth = "5f211c5b-6153-4493-83a0-7dd38841c971",
  DeltaRefreshJobComplete = "05b97013-7ffd-40fa-bb5a-e2572a8c87f6",
  /** NP-300: a Survey Product you have open changed (product id only; re-read it). Same value as the server. */
  CollaborationActivity = "a3c1e0b2-6f4d-4e8a-9b7c-2d5e8f1a0c34",
}

export type SocketData = {
  event:
    | SocketEventTypeEnum.Received
    | SocketEventTypeEnum.Message
    | SocketEventTypeEnum.Progress
    | SocketEventTypeEnum.Error
    | SocketEventTypeEnum.Auth
    | SocketEventTypeEnum.AuthError
    | SocketEventTypeEnum.RowCount
    | SocketEventTypeEnum.DeltaRefreshJobComplete
    | SocketEventTypeEnum.CollaborationActivity;
  data:
    | {
        wsCallId: string;
        totalRowCount: number;
        currentRowCount: number;
        rows: unknown[];
        signedUrl: string;
      }
    | any;
};

export enum SocketMessagesEnum {
  StopUserImpersonation = "a16956fe-ca36-4500-a1df-b61081b3eea8",
  Success = "710ebd77-ea69-40c4-8934-78c2bdcc7f59",
}
